import {
  ApiBlueprint,
  createApiFactory,
  createFrontendPlugin,
  discoveryApiRef,
  fetchApiRef,
  PageBlueprint,
} from '@backstage/frontend-plugin-api'
import { EntityCardBlueprint } from '@backstage/plugin-catalog-react/alpha'
import AssessmentIcon from '@material-ui/icons/Assessment'
import { createElement } from 'react'

import { aiReadinessApiRef, AiReadinessClient } from './api'
import { rootRouteRef } from './routes'

const aiReadinessApi = ApiBlueprint.make({
  name: 'ai-readiness',
  params: defineParams =>
    defineParams(
      createApiFactory({
        api: aiReadinessApiRef,
        deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
        factory: ({ discoveryApi, fetchApi }) => new AiReadinessClient({ discoveryApi, fetchApi }),
      })
    ),
})

const aiReadinessPage = PageBlueprint.make({
  params: {
    path: '/ai-readiness',
    routeRef: rootRouteRef,
    title: 'AI Readiness',
    icon: createElement(AssessmentIcon),
    loader: () => import('./components/AiReadinessRouter.tsx').then(m => createElement(m.AiReadinessRouter)),
  },
})

const entityAiReadinessCard = EntityCardBlueprint.make({
  name: 'ai-readiness',
  params: {
    filter: { kind: 'component' },
    loader: () =>
      import('./components/AiReadinessEntityCard/AiReadinessEntityCard.tsx').then(m =>
        createElement(m.AiReadinessEntityCard)
      ),
  },
})

export const aiReadinessPlugin = createFrontendPlugin({
  pluginId: 'ai-readiness',
  routes: {
    root: rootRouteRef,
  },
  extensions: [aiReadinessApi, aiReadinessPage, entityAiReadinessCard],
})

export default aiReadinessPlugin
